export const API_URL = 'https://mgapi.dnb3e9vcn349v39d.xyz';